/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import { useState } from "react";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
// import Apps from "pages/Presentation/sections/Apps";

import HomeFooter from "examples/Footers/HomeFooter";

import footerRoutes from "footer.routes";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// // Material Kit 2 React examples
// import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// // Author page sections
// import Profile from "pages/LandingPages/Author/sections/Profile";
// import Posts from "pages/LandingPages/Author/sections/Posts";
// import Contact from "pages/LandingPages/Author/sections/Contact";
// import Footer from "pages/LandingPages/Author/sections/Footer";

// // Routes
// import routes from "routes";

// // Images
import featureImage from "assets/images/Jellyfish-transparent.png";
import phoneImage1 from "assets/images/jellyfish-phone-nutrition.png";
import phoneImage2 from "assets/images/jellyfish-phone-camera.png";
import phoneImage3 from "assets/images/jellyfish-phone-gi.png";
import appStoreButtonImage from "assets/images/appStoreButtonImage.png";
import playStoreButtonImage from "assets/images/googlePlayButtonImage.png";

function Jellyfish() {
  const [feedbackText, setFeedbackText] = useState("");

  const sendFeedback = () => {
    setFeedbackText("");
  };

  return (
    <>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: 8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
            rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox
          display="flex"
          alignItems="center"
          borderRadius="xl"
          my={2}
          py={2}
        >
          <Container>
            <Grid container spacing={2} alignItems="center">
              <Grid item md={8} sx={{ mb: 0 }}>
                <MKTypography variant="h2" color="dark">
                  Jellyfish
                </MKTypography>
                <MKTypography variant="h5" color="dark" opacity={0.8}>
                  Simple Food Nutrition
                </MKTypography>
              </Grid>
              <Grid item md={4} sx={{ mb: 0 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item md={6} sx={{ mb: 0 }}>
                    <a href="https://itunes.apple.com/us/app/tempo-slowmo/id460008289?mt=8">
                      <img
                        alt="moo"
                        src={appStoreButtonImage}
                        width="100%"
                        style={{ maxWidth: 200 }}
                      />
                    </a>
                  </Grid>
                  <Grid item md={6} sx={{ mb: 0 }}>
                    <a href="https://play.google.com/store/apps/details?id=com.martianstorm.jellyfish">
                      <img
                        alt="moo"
                        src={playStoreButtonImage}
                        width="100%"
                        style={{ maxWidth: 200 }}
                      />
                    </a>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={4} />
              <Grid item md={4} sx={{ mb: 0 }}>
                <MKBox
                  my={2}
                  py={2}
                  component="img"
                  width="60%"
                  marginLeft="20%"
                  src={featureImage}
                />
              </Grid>
              <Grid item md={4} />
            </Grid>
            <Grid container>
              <Grid item md={12} sx={{ mb: 0 }}>
                <MKTypography
                  variant="body1"
                  fontWeight="bold"
                  color="dark"
                  mb={2}
                >
                  Jellyfish: Your Friendly Nutrition Assistant
                </MKTypography>
                <MKTypography variant="body1" color="dark" mb={2}>
                  Dive into a healthier lifestyle with Jellyfish, your personal
                  nutrition assistant! Whether you want to understand what’s in
                  your food, or make healthier choices, Jellyfish is here to
                  help—always with a friendly touch.
                </MKTypography>
                <Grid container>
                  <Grid item md={4} />
                  <Grid item md={4} sx={{ mb: 0 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item md={6} sx={{ mb: 0 }}>
                        <MKBox
                          my={2}
                          py={2}
                          component="img"
                          width="70%"
                          marginLeft="15%"
                          src={phoneImage2}
                          sx={{ maxWidth: 200 }}
                        />
                      </Grid>
                      <Grid item md={6} sx={{ mb: 0 }}>
                        <MKBox
                          my={2}
                          py={2}
                          component="img"
                          width="100%"
                          src={phoneImage1}
                          sx={{ maxWidth: 200 }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item md={4} />
                </Grid>
                <MKTypography
                  variant="body1"
                  fontWeight="bold"
                  color="dark"
                  mb={2}
                >
                  Key Features:
                </MKTypography>
                <List sx={{ listStyleType: "disc", marginLeft: 4 }}>
                  <ListItem sx={{ display: "list-item" }}>
                    Meal Logging Made Easy: Enter a meal description, snap a
                    photo with your camera, choose a picture from your gallery,
                    or use your microphone to tell Jellyfish about your meal.
                    It&apos;s simple and flexible!
                  </ListItem>
                  <ListItem sx={{ display: "list-item" }}>
                    AI-Powered Analysis: Jellyfish uses advanced AI to identify
                    the ingredients in your meals and provide detailed
                    nutritional information. Ensure your food choices are
                    spot-on for your health goals.
                  </ListItem>
                  <ListItem sx={{ display: "list-item" }}>
                    Interactive and Fun: Enjoy the company of our cute Jellyfish
                    character who guides you through the app, offering tips and
                    encouraging messages.
                  </ListItem>
                  <ListItem sx={{ display: "list-item" }}>
                    Review and Refine: Double-check and refine the ingredient
                    lists Jellyfish generates to get the most accurate
                    nutritional information.
                  </ListItem>
                  <ListItem sx={{ display: "list-item" }}>
                    Subscription Benefits: Get unlimited access to all features
                    with a subscription. Dive deeper into your nutrition
                    analysis and make the most of Jellyfish!
                  </ListItem>
                </List>
                <MKTypography
                  variant="body1"
                  fontWeight="bold"
                  color="dark"
                  mb={2}
                  mt={2}
                >
                  Why Choose Jellyfish?
                </MKTypography>

                <MKTypography variant="body1" color="dark" mb={2}>
                  Jellyfish is not just a nutrition app—it&apos;s a fun and
                  friendly companion on your journey to better health. With its
                  easy-to-use interface and engaging character, Jellyfish makes
                  tracking your meals enjoyable and informative.
                </MKTypography>

                <MKTypography variant="body1" color="dark" mb={2}>
                  Perfect for anyone looking to understand their diet better and
                  make healthier choices
                </MKTypography>

                <Grid container>
                  <Grid item md={4} />
                  <Grid item md={4} sx={{ mb: 0 }}>
                    <MKBox
                      my={2}
                      py={2}
                      component="img"
                      width="60%"
                      marginLeft="20%"
                      src={phoneImage3}
                    />
                  </Grid>
                  <Grid item md={4} />
                </Grid>

                <MKTypography
                  variant="body1"
                  fontWeight="bold"
                  color="dark"
                  mb={2}
                >
                  Subscribe for Unlimited Access
                </MKTypography>

                <MKTypography variant="body1" color="dark" mb={2}>
                  Enjoy a seamless experience with unlimited access to all of
                  Jellyfish&apos;s features. Subscribe now and support our
                  friendly Jellyfish, who has little mouths to feed!
                </MKTypography>

                <MKTypography
                  variant="body1"
                  fontWeight="bold"
                  color="dark"
                  mb={2}
                >
                  Download Jellyfish Today
                </MKTypography>

                <MKTypography variant="body1" color="dark" mb={2}>
                  Take the plunge into better health with Jellyfish. Download
                  now and start your journey towards a healthier you, one meal
                  at a time.
                </MKTypography>

                <MKTypography variant="body1" color="dark"></MKTypography>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>

      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: 8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
            rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox p={3}>
          <Container>
            <MKTypography variant="h3" color="dark">
              Get In Touch
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={3} mt={2}>
              We have tried to keep Jellyfish as simple as possibler to use, but
              if there are any features you would like to see in the next
              version or if you have any problems using the app please do get in
              touch, we are always listening to your feedback.
            </MKTypography>
            <MKBox
              width="100%"
              component="form"
              method="post"
              autoComplete="off"
            >
              <Grid container spacing={3}>
                <Grid item xs={0} md={1} hd={2} />
                <Grid item xs={12} md={5} hd={4}>
                  <MKInput
                    variant="outlined"
                    label="Your full Name (optional)"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={5} hd={4}>
                  <MKInput
                    type="email"
                    variant="outlined"
                    label="Your email address (optional)"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={1} md={1} hd={2} />
                <Grid item xs={0} md={1} hd={2} />
                <Grid item xs={12} md={10} hd={8}>
                  <MKInput
                    value={feedbackText}
                    variant="outlined"
                    label="Your feedback"
                    InputLabelProps={{ shrink: true }}
                    multiline
                    fullWidth
                    rows={6}
                    onChange={(event) => setFeedbackText(event.target.value)}
                  />
                </Grid>
                <Grid item xs={0} md={1} hd={2} />
              </Grid>
              <Grid
                container
                item
                justifyContent="center"
                xs={12}
                mt={5}
                mb={2}
              >
                <MKButton
                  onClick={() => sendFeedback}
                  variant="gradient"
                  color="info"
                >
                  Send Feedback
                </MKButton>
              </Grid>
            </MKBox>
          </Container>
        </MKBox>
      </Card>

      <MKBox pt={6} px={1} mt={6}>
        <HomeFooter
          content={{
            privacyPolicyUrl: "/jellyfishPrivacyPolicy.html",
            ...footerRoutes,
          }}
        />
      </MKBox>
    </>
  );
}

export default Jellyfish;
